import { Component, OnInit } from '@angular/core';
import { HangfireService } from 'app/core/services/hangfire.service';


@Component({
  selector: 'hangfire-redirect',
  template: ''
})
export class HangfireRedirectComponent implements OnInit {
  constructor(private hangfireService: HangfireService) {}

  ngOnInit() {
    this.hangfireService.getToken().subscribe(
      response => this.hangfireService.openDashboard(response.accessToken),
      error => console.error('Unable to open Hangfire dashboard.', error)
    );
  }

}
